import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../services/language/language.service';

@Pipe({ name: 'translateOr', standalone: false })
export class TranslateOrPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}
  transform(key: string, fallback: string): string {
    const val = this.languageService.translate(key);
    // If translation not found (returns the same key), use fallback
    return val && val !== key ? val : fallback;
  }
}
